export default "/vendor/bigdog.324c78cf1e9a2cf18861c25c9586fb9b.ttf";